import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { copyToClipboard } from '@eika-infrastruktur/utils';
import { ErrorMessage } from '@eika/attention-message';
import { Button, LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../hooks/useTranslation';
import { errorTrackIds } from '../../utils/gtm/trackIDs/error';
import isServiceError from '../../utils/isServiceError';

import './VerboseErrorMessagWithRCID.scss';

export type VerboseErrorMessageWithRCIDProps = {
    title: string;
    description: string;
    systemErrorDescription: string;
    error: RequestExceptionWithResponse | null;
    refresh: () => void;
};

const VerboseErrorMessageWithRCID: React.FC<VerboseErrorMessageWithRCIDProps> = ({
    title,
    description,
    systemErrorDescription,
    error,
    refresh,
}) => {
    const { tryAgain, commonErrors } = useTranslation();
    const isSystemError = !!error && isServiceError(error);

    return (
        <ErrorMessage
            className="account-view__error-message"
            text={
                <span className="account-view__error-message-wrapper">
                    <span className="bold">{title}</span>
                    <span className="account-view__error-message-description">
                        {isSystemError ? systemErrorDescription : description}
                    </span>
                    {!isSystemError && error?.rcid && (
                        <span className="account-view__error-message-details">
                            <span className="account-view__error-message-rcid">{error.rcid}</span>
                            <LinkButton
                                className="account-view__error-message-button"
                                icon={IconTypes.COPY_24}
                                onClick={() => copyToClipboard(error.rcid)}
                                iconOnRightSide
                                data-track-id={errorTrackIds.copyRCIDNew.id}
                                data-track-linkname={commonErrors.copyRCID}
                            >
                                {commonErrors.copyRCID}
                            </LinkButton>
                        </span>
                    )}
                </span>
            }
            clickableItem={
                !isSystemError && (
                    <Button onClick={refresh} size="small">
                        {tryAgain}
                    </Button>
                )
            }
        />
    );
};

export default VerboseErrorMessageWithRCID;
